import { UntitledIcon } from '@faceup/icons'
import { ulPlus } from '@faceup/icons/ulPlus'
import { Upload, type UploadFile, type UploadProps } from '@faceup/ui-base'
import { type ReactNode, useContext } from 'react'
import { UiContext } from '../UiProvider/UiProvider'

export type UploadSinglePictureProps = {
  listType: Extract<NonNullable<UploadProps['listType']>, 'picture-circle' | 'picture-card'>
  file?: UploadFile | null
  emptyContent?: ReactNode
  onChange?: (file: UploadFile | null) => void
} & Omit<UploadProps, 'listType' | 'fileList' | 'defaultFileList' | 'onChange'>

export const UploadSinglePicture = ({
  file,
  emptyContent,
  onChange,
  ...props
}: UploadSinglePictureProps) => {
  return (
    <Upload
      {...props}
      fileList={file ? [file] : undefined}
      onChange={onChange ? ({ fileList }) => onChange(fileList[0] ?? null) : undefined}
      maxCount={1}
    >
      {!file && <EmptyContent emptyContent={emptyContent} />}
    </Upload>
  )
}

type EmptyContentProps = {
  emptyContent: ReactNode | undefined
}

const EmptyContent = ({ emptyContent }: EmptyContentProps) => {
  const { upload } = useContext(UiContext)
  if (emptyContent) {
    return emptyContent
  }
  return (
    <div className='flex flex-col items-center gap-1 text-[#0085FF]'>
      <UntitledIcon icon={ulPlus} size={20} />
      <div className='font-semibold'>{upload?.text ?? 'Upload'}</div>
    </div>
  )
}

UploadSinglePicture.getFileObjectFromUrl = (url: string): UploadFile => {
  return { uid: 'uploaded', name: 'image.png', status: 'done', url }
}
